module.exports = __webpack_public_path__ + "img/daftar_pesanan_merchant.9b6e868e.svg";